import { IPolicy } from "config";
import { IPolicyState } from "store/reducers/policy";

import { isEmpty } from "lodash-es";

export const isValidPolicy = (policy: IPolicyState | IPolicy) => {
  return !isEmpty(policy.id) && !isEmpty(policy.status);
};
